var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShared(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.70711 12.7071C2.31658 12.3166 2.31658 11.6834 2.70711 11.2929L8.28077 5.71923C8.6713 5.3287 9.30446 5.3287 9.69499 5.71923L15.2687 11.2929C15.6592 11.6834 15.6592 12.3166 15.2687 12.7071L9.69499 18.2808C9.30446 18.6713 8.6713 18.6713 8.28077 18.2808L2.70711 12.7071Z",
    fill: "#0A51C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.201 12.7071C5.81048 12.3166 5.81048 11.6834 6.201 11.2929L12.9393 4.55458C13.3298 4.16406 13.963 4.16406 14.3535 4.55458L21.0918 11.2929C21.4824 11.6834 21.4824 12.3166 21.0918 12.7071L14.3535 19.4454C13.963 19.8359 13.3298 19.8359 12.9393 19.4454L6.201 12.7071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36555 12.7071C6.97503 12.3166 6.97503 11.6834 7.36555 11.2929L12.9392 5.71923C13.3297 5.3287 13.9629 5.3287 14.3534 5.71923L19.9271 11.2929C20.3176 11.6834 20.3176 12.3166 19.9271 12.7071L14.3534 18.2808C13.9629 18.6713 13.3297 18.6713 12.9392 18.2808L7.36555 12.7071Z",
    fill: "#0A51C5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShared);
export default __webpack_public_path__ + "static/media/shared.e22f5d955960f8bdec15df354a5f0983.svg";
export { ForwardRef as ReactComponent };